<template>
  <v-container>
    <v-row><h2 class="ml-2">Liste point</h2>
<v-spacer/>
<v-btn class="ma-2" color="teal darken-2" @click="openSearch = true;" dark><v-icon>mdi-magnify</v-icon>Rechercher</v-btn>
<v-btn class="ma-2" color="teal darken-2" dark :to="{name: 'AdminPointAdd'}"><v-icon>mdi-map-marker-plus</v-icon>Ajouter un point</v-btn></v-row>
<v-container v-if="openSearch">
  <template>
    <v-row>
      <v-col>
      <v-select placeholder="terme" v-model="s.field" label="terme" :items="search_fields" return-object outlined></v-select>
    </v-col><v-col>
      <v-text-field outlined v-model="s.term" label="valeur" placeholder="valeur"></v-text-field>
</v-col>
<v-col>

<v-btn :disabled="s.field =='' || s.term.length == 0 " color="teal darken-2" dark @click="recherche()"><v-icon>mdi-magnify</v-icon></v-btn>
<v-btn v-if="search.length > 0" color="teal darken-2" dark @click="delete_search()"><v-icon>mdi-delete</v-icon></v-btn>

</v-col>
    </v-row>
  </template>
</v-container>
<ListComponent :search="search" :headers="headers" entity="pois" :show="show" :edit="edit"  />
  </v-container>

</template>

<script>
import ListComponent from '../list_component';

export default {
  components: {ListComponent},
  data: () => ({
    search: [],
    s: {field: '', term: '', type: ''},
    openSearch: false,
    search_fields: [{value: 'name_fr', text:'nom', type: 'gtandlt'}, {value: 'city', text:'commune', type:'in'}],
    headers:[{value: 'd.name_fr', text: 'Nom'}, {value: 'd.city', text: 'Commune'}, {value: '', text: 'Actions'}]
  }),
  mounted() {
    if (this.$route.hash.length > 0) {
      this.$store.dispatch('openDialog', {id: this.$route.hash.split('#')[1]});
    }
  },
  methods: {
    delete_search() {
      this.search = [];
      this.s = {field: '', term: ''};
    },
    recherche() {
      this.search = [];
      this.search.push(this.s);
      //this.s = {field: '', term: ''};
    },
    show(p){
      this.$store.dispatch('openDialog', {id: p.ref, data: p.d});

    },
    edit(p) {

      this.$store.dispatch('setDialogEdit', {m: true, e: 'points', data: p.d, id:p.ref});
    },

  }
}
</script>
